import React, { useState } from 'react';
import styles from './ToolbarRow.module.css';

interface ToolbarRowProps {
  children: React.ReactNode;
  className?: string;
}

const ToolbarRow: React.FC<ToolbarRowProps> = ({ children, className }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={[
      styles['toolbar-row'],
      expanded ? styles.expanded : '',
      className,
    ].filter(Boolean).join(' ')}
    >
      {children}
      <button
        type="button"
        className={styles['filter-toggle']}
        onClick={() => setExpanded((current) => !current)}
        aria-expanded={expanded}
      >
        <span className="material-symbols-outlined" aria-hidden="true">filter_list</span>
        {expanded ? 'Ocultar filtros' : 'Filtros'}
      </button>
    </div>
  );
};

export default ToolbarRow;
